import { PageHeader, Stack, TabNav, type TabNavItem } from '@ui';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router';
import { PageActionsProvider, PageActionsSlot } from '../../app/PageActions';
import { useSession } from '../identity/session';
import { ExportButton } from '../reports/components/ExportButton';
import type { ExportList } from '../reports/api';

/** Frame of the colony pages: title and tabs (overview, treatments, …). */
export function ApiaryLayout() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { can } = useSession();
  const tabs: TabNavItem[] = (
    [
      {
        key: 'colonies',
        label: t('apiary.tabs.colonies'),
        href: '/voelker',
      } satisfies TabNavItem,
      ...(can('treatments.read')
        ? [
            {
              key: 'treatments',
              label: t('apiary.tabs.treatments'),
              href: '/voelker/behandlungen',
            } satisfies TabNavItem,
            {
              key: 'mites',
              label: t('apiary.tabs.miteCounts'),
              href: '/voelker/milbenkontrollen',
            } satisfies TabNavItem,
          ]
        : []),
      ...(can('feedings.read')
        ? [
            {
              key: 'feedings',
              label: t('apiary.tabs.feedings'),
              href: '/voelker/fuetterungen',
            } satisfies TabNavItem,
          ]
        : []),
    ] as TabNavItem[]
  ).map((tab) => ({
    ...tab,
    active: tab.href === '/voelker' ? pathname === '/voelker' : pathname.startsWith(tab.href),
  }));
  const list: ExportList = pathname.startsWith('/voelker/behandlungen')
    ? 'treatments'
    : pathname.startsWith('/voelker/milbenkontrollen')
      ? 'mite-counts'
      : pathname.startsWith('/voelker/fuetterungen')
        ? 'feedings'
        : 'colonies';
  return (
    <PageActionsProvider>
      <Stack gap={4}>
        <PageHeader
          title={t('apiary.title')}
          actions={
            <>
              <PageActionsSlot />
              <ExportButton list={list} />
            </>
          }
        />
        <TabNav label={t('apiary.tabs.label')} items={tabs} />
        <Outlet />
      </Stack>
    </PageActionsProvider>
  );
}
